module.exports = __webpack_public_path__ + "static/img/main_ticket.41f58ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20-mo/main_ticket.png
// module id = 14
// module chunks = 0